import React from "react";
import {useParams} from "react-router-dom";
import {PageHeader} from "../../../components/PageHeader";
import {saveNotice} from "../../../api/notice/NoticeService";
import ContentRegisterForm from "../shared/ContentRegisterForm";

function NoticeCreate() {
    const {type: typeParam} = useParams();
    const gubun = typeParam === "request" ? "request" : "main";

    const pageHeader = gubun === "request"
        ? <PageHeader header="요청공지사항" indicator="서비스요청 > 요청공지사항 > 등록" />
        : <PageHeader header="공지사항관리" indicator="환경설정 > 알람관리 > 공지사항관리 > 등록" />;

    return (
        <ContentRegisterForm
            gubun={gubun}
            pageHeader={pageHeader}
            cancelPath={`/settings/noticelist/${gubun}`}
            onSubmit={saveNotice}
            successPath={(id) => `/settings/notice/${id}`}
        />
    );
}

export {NoticeCreate};
